export default __webpack_public_path__ + "static/media/teapot.be181141.png";